import { render, staticRenderFns } from "./Consumptions.vue?vue&type=template&id=02e29fd0"
import script from "./Consumptions.vue?vue&type=script&lang=ts"
export * from "./Consumptions.vue?vue&type=script&lang=ts"
import style0 from "./Consumptions.vue?vue&type=style&index=0&id=02e29fd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports